import { mainStore } from '../stores/MainStore';

export const useMainStore = () => {
  return mainStore;
};
